/**
 * Envio de telas para o Google Analytics.
 *
 * Um app de página única só dispara o page_view do carregamento inicial; as telas seguintes precisam
 * ser enviadas na troca de rota. Enviamos apenas o caminho: a query string carrega busca por telefone,
 * ids de campanha e filtros — dados de clientes que não devem sair da aplicação.
 */

declare global {
  interface Window {
    gtag?: (command: string, ...args: unknown[]) => void;
  }
}

// Em desenvolvimento o React monta os efeitos duas vezes; sem isso a mesma tela conta em dobro
let lastPath: string | null = null;

export function trackPageView(path: string, title?: string) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (path === lastPath) return;
  lastPath = path;

  const cleanLocation = window.location.origin + path;

  // set primeiro: vale também para os eventos automáticos do GA4 disparados nesta tela
  window.gtag('set', { page_location: cleanLocation, page_path: path });

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: cleanLocation,
    page_title: title || document.title,
  });
}
